export default __webpack_public_path__ + "static/teacher-with-flag-87ec35c039cce2addc1922cdb26cc78a.jpg";